import { Component, Input, OnInit, Output, EventEmitter, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetForInstallationAssign, AssetInstallationAssign, VendorInstallationAssign } from 'src/app/models/installation.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { InstallationService } from 'src/app/services/installation.service';
import { OrganizationTeamApiService } from 'src/app/services/organization-team-api.service';
import { PermissionsService } from 'shared-lib';
import { UserService } from 'src/app/services/user.service';

enum AssignmentTab {
  Vendor = 'Vendor',
  Installer = 'Installer',
}

@Component({
  selector: 'app-add-dt-installation',
  templateUrl: './add-dt-installation.component.html',
  styleUrls: ['../add-installation/add-installation.component.scss', './add-dt-installation.component.scss'],
})
export class AddDtInstallationComponent implements OnInit {
  @Input() isPopUp: boolean = false;
  @Output() closePopUpChange = new EventEmitter();
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;

  public AssignmentTab = AssignmentTab;
  selectedTab: AssignmentTab = AssignmentTab.Vendor;

  public searchAssets: string = '';
  mobileUsersForSelect: any[];
  assetsForSelect: AssetForInstallationAssign[];
  selectedAssets: AssetForInstallationAssign[] = [];

  installation: AssetInstallationAssign = new AssetInstallationAssign();
  vendorInstallation: VendorInstallationAssign = new VendorInstallationAssign();

  filterText: string = "";
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;

  vendorsForSelect: any[] = [];
  filteredVendors: any[] = [];
  vendorFilterText: string = "";
  isVendorDropdownOpened: boolean = false;
  tempVendorId: number = 0;

  constructor(
    private toastr: ToastrService,
    private userService: UserService,
    private installationService: InstallationService,
    private authService: AuthService,
    private organizationService: OrganizationTeamApiService,
    public permissionsService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.selectedTab = this.permissionsService.isDtMeterInstallationVendorAssignmentAllowed
      ? AssignmentTab.Vendor
      : AssignmentTab.Installer;
    this.loadAssetsForOptions();
    this.loadVendorsForOptions();
  }
  setTab(tab: AssignmentTab) {
    this.selectedTab = tab;
    this.searchAssets = '';
    this.selectedAssets = [];
    this.resetFieldAgent();
    this.vendorFilterText = '';
    this.tempVendorId = 0;
    this.isVendorDropdownOpened = false;
    this.loadAssetsForOptions();
  }
  isChecked(val: number) {
    return this.selectedAssets.some(x => x.id == val);
  }
  isAssetDisabled(asset: AssetForInstallationAssign) {
    if(this.selectedTab !== AssignmentTab.Installer || this.selectedAssets.length === 0) {
      return false;
    }
    return asset.organizationId != this.selectedOrganizationId();
  }
  closeModal() {
    this.closePopUpChange.emit();
  }
  search() {
    this.loadAssetsForOptions();
  }
  loadAgentsForOptions() {
    this.userService.getMobileUsersForSelectByAreas(this.filterText, this.selectedAreaIds(), this.authService.hasCimDataIntegration, this.selectedOrganizationId()).subscribe(
      (data) => {
        this.mobileUsersForSelect = data.data;
        if(this.mobileUsersForSelect.length == 0) {
          this.isDropdownOpened = false;
        }
        else {
          this.isDropdownOpened = true;
        }
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }
  loadAssetsForOptions() {
    const request = this.selectedTab === AssignmentTab.Vendor
      ? this.installationService.getAuthorizedDtsForVendorAssignOptions(this.searchAssets)
      : this.installationService.getAssetsForInstallationAssignOptions(this.searchAssets);
    request
      .subscribe(
        (response) => {
          this.assetsForSelect = response.body?.data ?? [];
        },
        (error) => {
          this.toastr.error('An error occurred.');
        }
      );
  }
  loadVendorsForOptions() {
    this.organizationService.getAllForSelect().subscribe(
      (response: any) => {
        this.vendorsForSelect = response?.data ?? [];
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  filterVendors() {
    if(this.vendorFilterText.length < 3) {
      return;
    }
    this.tempVendorId = 0;
    this.filteredVendors = this.vendorsForSelect.filter(x => x.name.toLowerCase().includes(this.vendorFilterText.trim().toLowerCase()));
    this.isVendorDropdownOpened = this.filteredVendors.length > 0;
  }
  selectVendor(id: number) {
    this.isVendorDropdownOpened = false;
    this.tempVendorId = id;
    this.vendorFilterText = this.vendorsForSelect.find(x => x.id == id)!.name;
  }
  submitVendor() {
    if(this.tempVendorId == 0) {
      this.toastr.warning('Please select valid vendor.');
      return;
    }

    this.vendorInstallation.organizationId = this.tempVendorId;
    this.vendorInstallation.assets = this.selectedAssets.map(x => x.id);

    this.installationService.assignVendorInstallations(this.vendorInstallation).subscribe(
      (response) => {
        const responseData = response.body;
        if(responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Vendor assigned');
          this.closePopUpChange.emit();
        }
        else {
          this.toastr.error(responseData?.message ?? 'An error occurred.');
        }
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  submit() {
    if(this.mobileUsersForSelect.filter(x => x.fullName == this.filterText.trim()).length > 0) {
      this.installation.assignedUserId = this.mobileUsersForSelect.filter(x => x.fullName == this.filterText.trim())[0].id;
      this.tempAssignedUserId = this.installation.assignedUserId;
    }
    else {
      this.tempAssignedUserId = 0;
      this.toastr.warning('Please select valid user.');
      return;
    }

    this.installation.assets = this.selectedAssets.map(x => x.id);

    this.installationService.assignAssetInstallations(this.installation).subscribe(
      (response) => {
        this.toastr.success('Installation reassigned');
        this.closePopUpChange.emit();
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  onChangeAsset(asset: AssetForInstallationAssign) {
    const previousAreaIds = this.selectedAreaIds();

    if (this.isChecked(asset.id))
      this.selectedAssets = this.selectedAssets.filter((item) => item.id != asset.id);
    else this.selectedAssets.push(asset);

    const currentAreaIds = this.selectedAreaIds();
    if (currentAreaIds.length != previousAreaIds.length || currentAreaIds.some(id => !previousAreaIds.includes(id)))
      this.resetFieldAgent();
  }

  selectedOrganizationId(): number | null {
    return this.selectedAssets.length > 0 ? this.selectedAssets[0].organizationId : null;
  }

  selectedAreaIds(): number[] {
    const areaIds = this.selectedAssets
      .filter(x => x.areaId != null)
      .map(x => x.areaId!);

    return [...new Set(areaIds)];
  }

  resetFieldAgent() {
    this.filterText = '';
    this.tempAssignedUserId = 0;
    this.installation.assignedUserId = 0;
    this.mobileUsersForSelect = [];
    this.isDropdownOpened = false;
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.installation.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsersForSelect.find(x => x.id == id);
    this.filterText = mobUser!.fullName;
  }

  filterMobileUsers() {
    if(this.filterText.length < 3) {
      return;
    }
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.loadAgentsForOptions();
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    const isOpened = this.isDropdownOpened || this.isVendorDropdownOpened;
    const clickedInside = isOpened && this.dropdownContainer?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isDropdownOpened = false;
      this.isVendorDropdownOpened = false;
    }
  }
}
